export class MovimientosRequest {
    public fechaInicio: string;
    public fechaFin: string;
    public fechaCorte: string;
    public periodo: number;
    public numPagina: number;
    public tamPagina: number;
    constructor(){
        this.fechaInicio = null;
        this.fechaFin = null;
        this.fechaCorte = null;
        this.periodo = null;
        this.numPagina = null;
        this.tamPagina = null;
    }
}